<template>
  <v-card>
    <v-card-title class="py-2 title">
      <v-icon class="mr-2">assignment</v-icon>
      <div class="title info--text">Information</div>
    </v-card-title>
    <v-divider />
    <template v-if="editForm">
      <v-card-actions>
        <v-btn @click="addMetadata()" color="success" small :loading="isLoading">
          <v-icon class="mr-1">add</v-icon>
          {{ $t("Button.Add") }}
        </v-btn>
      </v-card-actions>
      <v-divider />
    </template>

    <v-data-table :headers="metadataHeaders" disable-initial-sort hide-headers :items="metadataItems" hide-actions class="elevation-1">
      <template v-slot:items="{ item, index }">
        <tr :class="{ alternate: index % 2 == 0 }">
          <td class="text-xs-left font-weight-medium">{{ item.Field }}</td>
          <td class="text-xs-left">{{ getMetadataValue(item) }}</td>
          <td v-if="editForm" class="text-xs-right">
            <v-tooltip v-if="item.onEdit" :open-delay="500" right>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="item.onEdit(item)" icon>
                  <v-icon color="warning">edit</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Button.Edit") }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

    <EditDiscreteCategoryDialog ref="editDiscreteCategoryDialog" />

    <AddMetadataDialog ref="addMetadataDialog" :station="discreteStation" :metadata="metadata" @refresh="refreshMonitoringFeature" />
    <EditMetadataDialog ref="editMetadataDialog" :station="discreteStation" :metadata="metadata" @refresh="refreshMonitoringFeature" />
  </v-card>
</template>

<script>
  import EditDiscreteCategoryDialog from './ManageMetadata/EditDiscreteCategoryDialog'
  import AddMetadataDialog from './ManageMetadata/AddMetadataDialog'
  import EditMetadataDialog from './ManageMetadata/EditMetadataDialog'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  import {
    pluralize,
  } from '@/helpers/strings'

  import {
    SOURCE_TYPES,
    SOURCE_TYPES_DATA_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const dataSources = createNamespacedHelpers('datasource')

  import {
    getMetadataValue,
  } from '@/helpers/metadata'

  export default {
    components: {
      EditMetadataDialog,
      AddMetadataDialog,
      EditDiscreteCategoryDialog,
    },
    props: {
      editForm: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        SOURCE_TYPES,
        refreshParams: {
          discreteMetadata: {
            sourceTypes: [SOURCE_TYPES.discreteEnvirodata],
            sourceTypeProperties: [
              [SOURCE_TYPES_DATA_TYPES.metadata],
            ],
          },
        },
        isLoading: false,
      }
    },
    computed: {
      ...monitoringFeatures.mapGetters([
        'currentFeatureDataSourceIndexByType',
      ]),
      ...dataSources.mapGetters([
        'dataSourceIndex',
      ]),
      featureDataSource() {
        return this.currentFeatureDataSourceIndexByType[SOURCE_TYPES.discreteEnvirodata]
      },
      discreteStation() {
        return this.dataSourceIndex[SOURCE_TYPES.discreteEnvirodata][this.featureDataSource.SourceId]
      },
      featureDataSourceData() {
        return this.featureDataSource.Data
      },
      metadata() {
        return this.featureDataSourceData.metadata
      },
      metadataHeaders() {
        let headers = [{
          text: 'Field',
          value: 'Field',
        },
        {
          text: 'FieldType',
          value: 'FieldType',
        },
        ]

        if (this.editForm) {
          headers.push({
            text: 'Actions',
            value: 'action',
          })
        }

        return headers
      },
      metadataItems() {
        let staticMetadata = [
          //   {
          //   Field: 'Station Name',
          //   FieldType: 'String',
          //   FieldValue: this.discreteStation.LocationIdentifier,
          //   Ordinal: 0,
          //   onEdit: this.editName,
          // },
          {
            Field: 'Station Category',
            FieldType: 'String',
            FieldValue: this.discreteStation && this.discreteStation.LocationType,
            Ordinal: 1,
            onEdit: this.editCategory,
          },
          {
            Field: 'Data Type',
            FieldType: 'String',
            FieldValue: 'Discrete Data',
            Ordinal: 2,
          },
        ]

        let metadata = this.metadata.map(metadatum => ({
          ...metadatum,
          onEdit: this.editMetadata,
        }))

        return [...staticMetadata, ...metadata]
      },
    },
    methods: {
      ...monitoringFeatures.mapActions(['refreshCurrentMFDetails']),
      getMetadataValue,
      pluralize,
      addMetadata() {
        this.$refs.addMetadataDialog.show()
      },
      editMetadata(item) {
        this.$refs.editMetadataDialog.show(item)
      },
      editName() {
        this.$refs.editNameDialog.show()
      },
      editCategory() {
        this.$refs.editDiscreteCategoryDialog.show()
      },
      async refreshMonitoringFeature() {
        try {
          this.isLoading = true
          await this.refreshCurrentMFDetails(this.refreshParams.discreteMetadata)
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>